import { render } from "./VFlex.vue?vue&type=template&id=0b06a8c1&scoped=true"
import script from "./VFlex.vue?vue&type=script&lang=js"
export * from "./VFlex.vue?vue&type=script&lang=js"

import "./VFlex.vue?vue&type=style&index=0&id=0b06a8c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b06a8c1"]])

export default __exports__